import React from "react";
import { Route, Redirect } from "react-router-dom";
import Home from "./pages/Home";
import Bio from "./pages/Bio";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Modal from "./components/Modal";
import { ModalSwitch, ModalRoute } from "react-router-modal-gallery";

const routes = [
  {
    exact: true,
    path: "/",
    component: Home,
  },
  {
    exact: true,
    path: "/bio",
    component: Bio,
  },
  {
    exact: true,
    path: "/services",
    component: Services,
  },
  {
    defaultParentPath: "/",
    modal: true,
    path: "/contact",
    component: Contact,
  },
  {
    path: "*",
    render: () => <Redirect to="/" />,
  },
];

const modalRoutes = routes
  .filter((route) => route.modal)
  .map((route) => <ModalRoute key={route.path} {...route} />);

const Routes = () => (
  <ModalSwitch
    renderModal={({ open, redirectToBack }) => (
      <Modal open={open} scroll="body" onExited={redirectToBack}>
        {modalRoutes}
      </Modal>
    )}
  >
    {routes.map((route) =>
      route.modal ? (
        <ModalRoute key={route.path} {...route} />
      ) : (
        <Route key={route.path} {...route} />
      )
    )}
  </ModalSwitch>
);

export default Routes;
